import i, { forwardRef as f } from "react";
import s from "../../atoms/Button/Button.js";
const l = f(function({ icon: t, children: o, testId: n = "fs-icon-button", "aria-label": r, size: a = "regular", variant: e, ...u }, c) {
  return i.createElement(s, { ref: c, "data-fs-button": !0, "data-fs-icon-button": !0, variant: e ?? "tertiary", icon: t, "aria-label": r, testId: n, size: a, ...u }, o);
}), B = l;
export {
  B as default
};
